<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/home' }">资产总览</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="assets-detail">
            <div class="assets-title">
                <span class="fund-name">{{ assetsInfo.fundname }}</span>
                <span class="fund-code">{{ assetsInfo.fundcode }}</span>
                <span class="fund-detail" v-on:click="gotoDetail">基金详情</span>
            </div>
            <div class="assets-amount">
                <div class="amount-left">
                    <div class="amount-top">
                        <div class="amount-label">
                            持仓金额
                            <span style="color: var(--color-text-accent)">(元)</span>
                        </div>
                        <!-- <div class="channel-label">
                            {{ assetsInfo.sourceflag == "2" ? "代销" : "直销" }}
                            <img :src="require('../../assets/img/channel-ic.png')" alt="" />
                        </div> -->
                    </div>
                    <div class="assets-total">
                        {{ $util.fmtNum(assetsInfo.marketvalue) }}
                    </div>
                    <div v-if="$util.getConfig().hideFunc" class="btns">
                        <div
                            v-for="(item, index) in btns"
                            :key="index"
                            class="button"
                            :class="{ 'disabled-btn': item === '取现' && !canRedemption }"
                            v-on:click="dealAssets(index)"
                        >
                            {{ item }}
                        </div>
                    </div>
                </div>
                <div class="sep-line"></div>
                <div class="amount-right">
                    <div v-for="(item, index) in profits" :key="index" class="profit-item">
                        <div class="profit-type">
                            {{ item.text }}
                        </div>
                        <div v-if="assetsInfo.fundshowtype != '5' && index == 2" class="profit-val">
                            {{ item.val }}
                        </div>
                        <div
                            v-else
                            class="profit-val"
                            :class="item.oldVal > 0 ? 'add' : item.oldVal < 0 ? 'reduce' : ''"
                        >
                            {{ item.val }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="postChargeDescribe" class="add-administration" style="margin-bottom: 20px">
                {{ postChargeDescribe }}
            </div>
            <share-detail
                v-if="assetsInfo"
                :fundshowtype="assetsInfo.fundshowtype"
                :vol-list="assetsInfo.fundArr"
                v-on:changeDividendmethod="changeDividendmethod"
            ></share-detail>
            <assets-trade-detail
                v-if="currtPageSourceflag != '2'"
                :fundcode="assetsInfo.fundcode"
                :queryfundflag="assetsInfo.assetshowtype == '1' ? '0' : '1'"
                :businessflag="assetsInfo.businessflag"
            ></assets-trade-detail>
            <dxassets-trade-detail
                v-if="currtPageSourceflag != '1'"
                :fundcode="assetsInfo.fundcode"
                :queryfundflag="assetsInfo.assetshowtype == '1' ? '0' : '1'"
                :businessflag="assetsInfo.businessflag"
            ></dxassets-trade-detail>
            <!-- <div v-if="assetsInfo.fundshowtype != '5'" class="dividend-method-contain">
                <div class="dividend-header">
                    <div class="title-line"></div>
                    <span class="title-content">分红方式</span>
                </div>
                <div v-for="(item, index) in assetsInfo.fundArr" :key="index">
                    <div v-if="item.sourceflag !== '2'" class="dividend-method">
                        <div v-if="item.sourceflag == '1'">
                            {{
                                $cache.getDict("110080", item.bankcode) +
                                "-" +
                                $cache.getDict("110079", item.paycenterid) +
                                (item.depositcard ? "(" + item.depositcard.substr(-4, 4) + ")" : "")
                            }}
                        </div>
                        <div
                            v-if="item.isupdatedividend != '1' && item.sourceflag == '1'"
                            style="display: flex; align-items: center; cursor: pointer"
                            v-on:click="changeDividendmethod(item)"
                        >
                            <div style="margin-right: 4px; color: var(--color-text-regular)">
                                {{ $cache.getDict("90273", item.dividendmethoddetail) }}
                            </div>
                            <i
                                v-if="item.sourceflag != '2' && $util.getConfig().hideFunc"
                                aria-hidden="true"
                                class="el-icon-arrow-right"
                                style="color: var(--color-text-accent)"
                            ></i>
                        </div>

                        <div v-else>
                            <span v-if="item.sourceflag == '1'">待确认</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
        <my-dialog
            class="my-dialog-contain"
            title="修改分红方式"
            :visible="dialogVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div style="margin-left: 25px; margin-top: 20px">
                <p class="dialog-title">
                    {{ currentDivInfo.fundname }}({{ currentDivInfo.fundcode }})
                </p>
                <p class="bonus-way">
                    当前分红方式:
                    <span class="red-color">
                        {{ $cache.getDict("110001", currentDivInfo.dividendmethod) }}
                    </span>
                </p>
                <div class="bonus-upd">
                    修改分红方式：
                    <el-select v-model="selectBonusWay" placeholder="请选择">
                        <el-option
                            v-for="item in bonusWayList"
                            :key="item.subitem"
                            :label="item.subitemname"
                            :value="item.subitem"
                        ></el-option>
                    </el-select>
                </div>
                <div v-if="isPwdCheck" class="bonus-upd">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;交易密码：
                    <el-input
                        v-model.trim="tradePwd"
                        style="width: 220px"
                        :type="pwdType"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    >
                        <i
                            slot="suffix"
                            class="icon-eye-postion"
                            :class="iconCla"
                            aria-hidden="true"
                            v-on:click="pwdTypeChange"
                        />
                    </el-input>
                </div>
                <div class="dialog-footer">
                    <el-button class="footer-button cancel" v-on:click="dialogVisible = false">
                        取 消
                    </el-button>
                    <el-button class="footer-button" type="primary" v-on:click="confirmUpd">
                        确 定
                    </el-button>
                </div>
            </div>
        </my-dialog>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import shareDetail from "@/components/fund/shareDetail";
import assetsTradeDetail from "@/components/fund/assetsTradeDetail";
import dxassetsTradeDetail from "@/components/fund/dxassetsTradeDetail";
import myDialog from "@/components/layout/myDialog.vue";
import fundSdxDialog from "@/components/form/fundSdxDialog";

export default {
    name: "AssetsDetail",
    components: {
        shareDetail,
        assetsTradeDetail,
        myDialog,
        fundSdxDialog,
        dxassetsTradeDetail
    },
    mixins: [mixin],
    data() {
        return {
            assetsInfo: {}, // 持仓信息
            // btns: ["申购", "赎回", "转换"],
            btns: [],
            totalUsableShare: 0, // 总可用份额
            profits: [], // 收益金额
            dialogVisible: false, // 修改分红方式弹窗
            bonusWayList: [],
            selectBonusWay: "",
            accountList: [],
            isPwdCheck: false,
            pwdType: "password", // 密码输入框类型
            iconCla: "fa fa-eye-slash", // 密码输入框图标
            tradePwd: "",
            sdxFundInfo: {},
            sdxDialogVisible: false,
            currentDivInfo: {},
            postChargeDescribe: "", // 附加管理费说明,
            xjbFundInfo: {},
            isShowPositionProfit: true, // 是否展示持仓收益
            currtPageSourceflag: ""
        };
    },
    computed: {
        canRedemption() {
            // 现金宝可用份额大于0时才能取现
            if (this.assetsInfo.assetshowtype === "1") {
                return Number(this.totalUsableShare) > 0;
            }
            return true;
        }
    },
    mounted() {
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        this.assetsInfo = JSON.parse(sessionStorage.getItem("_currentAsset"));
        // 计算总可用份额
        if (this.assetsInfo.fundArr && this.assetsInfo.fundArr.length > 0) {
            this.totalUsableShare = this.assetsInfo.fundArr.reduce((sum, item) => {
                return sum + (Number(item.usableremainshare) || 0);
            }, 0);
        }
        this.assetsInfo.isChange = this.$util.checkChange(this.assetsInfo);
        this.currtPageSourceflag = this.$route.query.sourceflag;
        this.isShowPositionProfit = this.$util.isShowPositionProfit();
        // 是否是纯代销
        const sourceflag = this.assetsInfo.fundArr.every((item) => item.sourceflag === "2");
        if (
            this.assetsInfo.assetshowtype == "2" &&
            this.xjbFundInfo.fundcode !== this.assetsInfo.fundcode
        ) {
            // 基础按钮配置
            const baseBtns = [
                this.assetsInfo.status == "1"
                    ? "认购"
                    : this.assetsInfo.assetshowtype == "1"
                    ? "充值"
                    : "申购",
                this.assetsInfo.bookingredeem == "1"
                    ? "预约赎回"
                    : this.assetsInfo.assetshowtype == "1"
                    ? "取现"
                    : "赎回",
                "转换",
                "定投"
            ];

            // 当 sourceflag 为 true 时过滤特定按钮
            this.btns = sourceflag
                ? baseBtns.filter((btn) => btn !== "转换" && btn !== "预约赎回" && btn !== "赎回")
                : baseBtns;
        } else {
            // 非 sourceflag 场景的赎回按钮
            let redeemBtn = [
                this.assetsInfo.bookingredeem == "1"
                    ? "预约赎回"
                    : this.assetsInfo.assetshowtype == "1"
                    ? "取现"
                    : "赎回"
            ];
            if (
                this.assetsInfo.assetshowtype == "1" &&
                this.xjbFundInfo.fundcode == this.assetsInfo.fundcode
            ) {
                redeemBtn = [
                    this.assetsInfo.status == "1"
                        ? "认购"
                        : this.assetsInfo.assetshowtype == "1"
                        ? "充值"
                        : "申购",
                    this.assetsInfo.bookingredeem == "1"
                        ? "预约赎回"
                        : this.assetsInfo.assetshowtype == "1"
                        ? "取现"
                        : "赎回"
                ];
            }

            // sourceflag 为 true 时隐藏赎回按钮
            this.btns = sourceflag ? [] : redeemBtn;
        }
        this.isPwdCheck = this.$cache.getPwdCheck("29");
        // this.assetsInfo.fundArr.forEach((item) => {
        //     if (item.dividendmethod == "0") {
        //         // 红利再投资
        //         item.dividendmethoddetail = "3";
        //     } else {
        //         if (item.dividendcashbacktype == "1") {
        //             // 自动充值至钱柜
        //             item.dividendmethoddetail = "1";
        //         } else {
        //             // 发放至银行卡
        //             item.dividendmethoddetail = "2";
        //         }
        //     }
        // });
        this.bonusWayList = this.$cache.getDict("110001");
        this.assignProfitData();
        // 查附加管理费说明
        fundApi
            .getFundLists({
                keyword: this.assetsInfo.fundcode,
                pagesize: 20,
                pagenum: 1
            })
            .then((res) => {
                if (res.data) {
                    const list = res.data.list;
                    if (list.length > 0) {
                        this.assetsInfo.businessflag = list[0].businessflag;
                        if (list[0].ext) {
                            try {
                                const extData = JSON.parse(list[0].ext.replace(/\n/g, "\\n"));
                                const extraItem = extData.find(
                                    (item) => item.definition === "附加管理费说明"
                                );
                                if (extraItem) {
                                    this.postChargeDescribe = extraItem.content;
                                }
                            } catch (error) {
                                console.error("解析失败:", error);
                            }
                        }
                    }
                }
            });
    },
    methods: {
        // 赋值收益数据
        assignProfitData() {
            let array = [];
            const item1 = {
                text: this.assetsInfo.profitdate
                    ? `${format(this.assetsInfo.profitdate, "MM-DD")}收益(元)`
                    : "收益(元)",
                oldVal: this.assetsInfo.lastprofit,
                val: this.$util.fmtNum(this.assetsInfo.lastprofit)
            };
             // 判断是否为货币基金且隐藏持仓收益
            const isCurrencyFund = this.assetsInfo.fundshowtype === '5';
            const showTotalProfit = !this.isShowPositionProfit && isCurrencyFund;

            const item2 = showTotalProfit
                ? {
                      text: "累计收益(元)",
                      oldVal: this.assetsInfo.totalprofit,
                      val: this.$util.fmtNum(this.assetsInfo.totalprofit)
                  }
                : {
                      text: "持仓收益(元)",
                      oldVal: this.assetsInfo.currentprofit,
                      val: this.$util.fmtNum(this.assetsInfo.currentprofit)
                  };
            array.push(item1, item2);
            if (this.assetsInfo.fundshowtype == "5") {
                // 货币基金
                const item3 = {
                    text: "万份收益",
                    oldVal: this.assetsInfo.fundincomeunit,
                    val: this.$util.fmtNum(this.assetsInfo.fundincomeunit, 4)
                };
                const item4 = {
                    text: "七日年化收益率",
                    oldVal: this.assetsInfo.growthrate,
                    val: this.formatterRate(this.assetsInfo.growthrate)
                };
                array.push(item3, item4);
            } else {
                // 非货币基金
                const item3 = {
                    text: this.assetsInfo.navdate
                        ? `最新净值(${this.$util.fmtDate(this.assetsInfo.navdate)})`
                        : "最新净值",
                    oldVal: this.assetsInfo.nav,
                    val: this.$util.fmtNum(this.assetsInfo.nav, 4)
                };
                const item4 = {
                    text: "日涨幅",
                    oldVal: this.assetsInfo.dayfloatprofit,
                    val: this.formatterRate(this.assetsInfo.dayfloatprofit)
                };
                array.push(item3, item4);
            }
            this.profits = array;
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            return this.$util.fmtNum(rate) + "%";
        },
        // 跳转到基金详情
        gotoDetail() {
            this.$util.toFundDetailPage(this.assetsInfo.fundcode);
        },
        /* 密码显示或隐藏处理 */
        pwdTypeChange() {
            this.pwdType = this.pwdType === "text" ? "password" : "text";
            this.iconCla = this.pwdType === "text" ? "fa fa-eye" : "fa fa-eye-slash";
        },
        // 显示分红方式弹窗
        changeDividendmethod(val) {
            if (!this.$util.getConfig().hideFunc) return;
            if (val.sourceflag == "2") {
                this.$message.warning("请至代销机构修改");
                return;
            }
            this.currentDivInfo = val;
            this.tradePwd = "";
            this.selectBonusWay = this.currentDivInfo.dividendmethod;
            this.dialogVisible = true;
        },
        // 关闭分红方式弹窗
        dialogClose() {
            this.dialogVisible = false;
        },
        // 修改分红方式
        async confirmUpd() {
            if (this.selectBonusWay == this.currentDivInfo.dividendmethod) {
                this.$message.warning("您暂未修改分红方式");
                return;
            }
            if (this.isPwdCheck && this.tradePwd.length == 0) {
                this.$message.warning("交易密码不能为空");
                return;
            }
            let param = {
                fundcode: this.currentDivInfo.fundcode,
                sharetype: this.assetsInfo.sharetype,
                dividendmethod: this.selectBonusWay == "0" ? "0" : "1",
                transactionaccountid: this.currentDivInfo.transactionaccountid,
                tradepassword: this.$util.enc(this.tradePwd) || "",
                tradmode: "0"
            };
            // if (this.selectBonusWay == "1" || this.selectBonusWay == "2") {
            //     param.dividendcashbacktype = this.selectBonusWay == "1" ? "1" : "0";
            // }
            const res = await fundApi.tradeDivideModify(param);
            if (res.code === "0") {
                this.$message({
                    type: "success",
                    message: "分红方式修改成功！"
                });
                this.$set(this.currentDivInfo, "isupdatedividend", 1);
                this.$set(
                    this.currentDivInfo,
                    "perdefdividendmethod",
                    this.selectBonusWay == "0" ? "0" : "1"
                );
                // this.$set(this.currentDivInfo, "dividendmethoddetail", this.selectBonusWay);
                // if (this.selectBonusWay == "3") {
                //     // 红利再投资
                //     this.$set(this.currentDivInfo, "dividendmethod", "0");
                // } else {
                //     // 现金分红
                //     this.$set(this.currentDivInfo, "dividendmethod", "1");
                // }
                this.assetsInfo.fundArr.forEach((item) => {
                    if (item.transactionaccountid == this.currentDivInfo.transactionaccountid) {
                        item.dividendmethod = this.currentDivInfo.dividendmethod;
                        // item.dividendmethoddetail = this.currentDivInfo.dividendmethoddetail;
                        item.isupdatedividend = this.currentDivInfo.isupdatedividend;
                    }
                });
                sessionStorage.setItem("_currentAsset", JSON.stringify(this.assetsInfo));
                this.dialogVisible = false;
            }
        },
        // 操作按钮事件
        dealAssets(index) {
            // 取现按钮置灰时不可点击
            if (this.btns[index] === "取现" && !this.canRedemption) {
                return;
            }
            let array = [];
            // 是否是纯代销
            const sourceflag = this.assetsInfo.fundArr.every((item) => item.sourceflag === "2");
            if (
                this.assetsInfo.assetshowtype == "2" &&
                this.xjbFundInfo.fundcode !== this.assetsInfo.fundcode
            ) {
                // 基础数组配置
                const baseArray = [
                    "20,22",
                    this.assetsInfo.bookingredeem == "1" || this.assetsInfo.bookingredeem == "2"
                        ? "25"
                        : "24",
                    "36",
                    "59"
                ];

                // 当 sourceflag 为 true 时，过滤掉赎回/预约赎回（第二个元素）和转换（第三个元素）
                array = sourceflag
                    ? baseArray.filter((item) => item !== "36" && item !== "24" && item !== "25")
                    : baseArray;
            } else {
                // 非sourceflag场景的赎回按钮代码
                let redeemCode = [
                    this.assetsInfo.bookingredeem == "1" || this.assetsInfo.bookingredeem == "2"
                        ? "25"
                        : "24"
                ];
                if (
                    this.assetsInfo.assetshowtype == "1" &&
                    this.xjbFundInfo.fundcode == this.assetsInfo.fundcode
                ) {
                    redeemCode = [
                        "20,22",
                        this.assetsInfo.bookingredeem == "1" || this.assetsInfo.bookingredeem == "2"
                            ? "25"
                            : "24"
                    ];
                }
                // sourceflag为true时返回空数组，否则返回包含赎回代码的数组
                array = sourceflag ? [] : redeemCode;
            }
            let way = array[index];
            let moduleId = "";
            let flag = "0";
            if (way == "20,22") {
                if (this.assetsInfo.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            } else {
                moduleId = way;
            }
            if (moduleId == "20" || moduleId == "22" || moduleId == "36" || moduleId == "29") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25 定投59
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, this.assetsInfo);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            this.sdxFundInfo = {};
            if (way === "24" || way === "25") {
                let _url = "sellfund";
                if (way === "25") {
                    _url = "orderselllist";
                }
                if (fund.isSell) {
                    this.$message.warning(fund.isSell);
                    return;
                }
                const _fund = _this.$util.dataTaacFilter(fund);
                const _x = Object.assign({}, _fund, { way: way });
                sessionStorage.setItem("sellfund", JSON.stringify(_x));
                // 现金宝取现
                if (fund.assetshowtype == "1") {
                    _url = "currencyredemption";
                }
                this.$router.push({ name: _url, query: { fundcode: fund.fundcode } });
            } else if (way === "36") {
                let _url = "changefund";
                if (this.assetsInfo.isChange) {
                    this.$message.warning(this.assetsInfo.isChange + ",不能转换");
                    return;
                }
                fund.proto = "change";
                this.$util.fundRiskCheck(this, fund, (res) => {
                    if (res) {
                        _this.$util.getSdxProtocol(res, (data) => {
                            if (data) {
                                const _x = Object.assign({}, data, { way: way });
                                // 实时ta赎回转购
                                if (fund.assetshowtype == "1") {
                                    _url = "sellBuyFund";
                                }
                                sessionStorage.setItem(_url, JSON.stringify(_x));

                                this.$router.push({
                                    name: _url,
                                    query: { fundcode: _x.fundcode }
                                });
                            }
                        });
                    }
                });
            } else {
                // 购买或者定投
                if (way == "20,22" || way == "59") {
                    // 普通购买
                    if (way == "20,22" && fund.isBuy) {
                        this.$message.warning(fund.isBuy + "，不能申购");
                        return;
                    }
                    if (way == "59" && fund.isCurrency) {
                        this.$message.warning(fund.isCurrency);
                        return;
                    }
                    fund.proto = way == "59" ? "plan" : "buy";
                    this.$util.fundRiskCheck(this, fund, (res) => {
                        if (res) {
                            _this.$util.getSdxProtocol(res, (data) => {
                                if (data) {
                                    const _x = Object.assign({}, data, { way: way });
                                    this.sdxFundInfo = _x;
                                    // 现金宝充值和定投
                                    if (this.sdxFundInfo.assetshowtype == "1") {
                                        const _url =
                                            this.sdxFundInfo.way == "59"
                                                ? "autoaccess"
                                                : "currencycharge";
                                        this.$router.push({
                                            name: _url,
                                            query: { fundcode: this.sdxFundInfo.fundcode }
                                        });
                                    } else {
                                        this.sdxDialogVisible = true;
                                    }
                                }
                            });
                        }
                    });
                }
            }
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            let _url = this.sdxFundInfo.way == "59" ? "generalbuy" : "buyfund";
            sessionStorage.setItem(_url, JSON.stringify(this.sdxFundInfo));
            // 现金宝充值和定投
            // if (this.sdxFundInfo.assetshowtype == "1") {
            //     _url = this.sdxFundInfo.way == "59" ? "autoaccess" : "currencycharge";
            // }
            this.$router.push({
                name: _url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-detail {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid var(--color-divided);
    .assets-title {
        display: flex;
        align-items: center;
        .fund-name {
            font-size: 20px;
            font-weight: 500;
            color: var(--color-text-primary);
        }
        .fund-code {
            margin-left: 4px;
            font-size: 14px;
            font-weight: bold;
            color: var(--color-text-accent);
        }
        .fund-detail {
            margin-left: 4px;
            font-size: 14px;
            font-weight: normal;
            color: var(--color-redirect);
            cursor: pointer;
        }
    }
    .assets-amount {
        margin-top: 26px;
        height: 210px;
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        display: flex;
        align-items: center;
        .amount-left {
            margin-left: 50px;
            display: flex;
            flex-direction: column;
            width: 455px;
            .amount-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                .amount-label {
                    font-size: 16px;
                    font-weight: normal;
                    color: var(--color-text-primary);
                }
                .channel-label {
                    width: 80px;
                    height: 30px;
                    border-radius: 20px;
                    box-sizing: border-box;
                    border: 1px solid var(--color-primary);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: var(--color-primary);
                    font-size: 14px;
                    gap: 4px;
                }
            }
            .assets-total {
                margin-top: 15px;
                font-size: 32px;
                font-weight: 500;
                color: var(--color-primary);
                line-height: 28px;
            }
            .btns {
                margin-top: 30px;
                display: flex;
                gap: 11px;
                .button {
                    width: 106px;
                    height: 32px;
                    border-radius: 2px;
                    background: var(--color-bg-page);
                    box-sizing: border-box;
                    border: 1px solid var(--color-border-base);
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 32px;
                    text-align: center;
                    color: var(--color-primary);
                }
                /* 鼠标悬停时按钮的样式 */
                .button:hover {
                    color: var(--color-text-white);
                    background: var(--color-primary);
                    border: none;
                }
                .disabled-btn {
                    color: var(--color-text-accent);
                    border-color: var(--color-text-weak);
                    cursor: not-allowed;
                }
                .disabled-btn:hover {
                    background: transparent;
                    color: var(--color-text-accent);
                    border: 1px solid var(--color-text-weak);
                }
            }
        }
        .sep-line {
            margin-left: 73px;
            width: 1px;
            height: 130px;
            background: var(--color-divided);
        }
        .amount-right {
            margin-left: 50px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            row-gap: 30px;
            column-gap: 130px;
            .profit-item {
                display: flex;
                flex-direction: column;
                width: 150px;
                .profit-type {
                    font-size: 14px;
                    font-weight: normal;
                    line-height: 14px;
                    color: var(--color-text-regular);
                }
                .profit-val {
                    margin-top: 8px;
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 28px;
                    color: var(--color-text-primary);
                }
                .add {
                    color: var(--color-up);
                }
                .reduce {
                    color: var(--color-down);
                }
            }
        }
    }
    .dividend-method-contain {
        margin-top: 20px;
        padding: 16px;
        box-sizing: border-box;
        border: 1px solid var(--color-divided);
        .dividend-header {
            display: flex;
            align-items: center;
        }
        .dividend-method {
            padding: 16px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: var(--color-text-primary);
            border-bottom: 1px solid var(--color-divided);
        }
    }
}
.dialog-title {
    font-weight: bold;
    font-size: 20px;
    color: var(--color-text-primary);
}

.bonus-way {
    color: var(--color-text-primary);
    font-size: 18px;
    margin-top: 32px;
}

.bonus-upd {
    font-size: 14px;
    margin-top: 24px;
}

.red-color {
    color: var(--color-primary);
}

.dialog-footer {
    display: flex;
    gap: 20px;
    justify-content: center;
    text-align: center;
    margin-top: 24px;
}

.footer-button {
    width: 180px;
    height: 42px;
    border-radius: 2px;
}
.cancel {
    color: var(--color-text-regular);
    background: var(--button-second-bg);
    border-color: transparent;
}
.icon-eye-postion {
    position: relative;
    top: 10px;
}
.add-administration {
    font-size: 14px;
    padding: 8px;
    color: var(--color-primary);
    background: var(--color-bg-container);
    line-height: 20px;
}
</style>
